import React from 'react';
import styled from 'styled-components';
import { unsubscribe } from '../firestore';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img.attrs({
  src: require('./images/logo.png')
})`
  margin: 20px 0 0 0;
  width: 70px;
  height: 70px;
  display: flex;
`;

const Description = styled.div`
  text-align: center;
  line-height: 25px;
  font-size: 16px;
  margin: 15px;
`;

const Content = styled.div`
  display: flex;
`;

const Box = styled.div`
  display: flex;
  background-color: white;
  margin: 50px;
  border-radius: 10px;
  padding: 70px 50px;
  align-self: stretch;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Loading = () => (
  <div className="lds-roller">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);

const formatName = (firstName?: string, lastName?: string, email?: string) => {
  let str = '';
  if (firstName) {
    str += `${firstName} `;
  }
  if (lastName) {
    str += `${lastName} `;
  }
  if (email) {
    str += `<${email}>`;
  }
  return str;
};

interface UnsubscribePageState {
  firstName: string;
  lastName: string;
  email: string;
  isLoading: boolean;
  isError: boolean;
}

class UnsubscribePage extends React.Component<{}, UnsubscribePageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      isLoading: true,
      isError: false
    };
  }

  public async componentDidMount() {
    document.body.className = 'yellow-background';

    const id = window.location.pathname && window.location.pathname.slice(13);
    if (id) {
      this.setState({ isLoading: true });
      const result = await unsubscribe(id).catch(error =>
        this.setState({ isLoading: false, isError: true })
      );
      if (result) {
        this.setState(result.data);
        return this.setState({ isLoading: false });
      }
    }

    this.setState({ isLoading: false, isError: true });
  }

  public render() {
    const { isLoading, isError, firstName, lastName, email } = this.state;
    let content;
    if (isLoading) {
      content = <Loading />;
    } else if (isError) {
      content = <Description>Failed to unsubscribe.</Description>;
    } else {
      content = (
        <Description>
          {formatName(firstName, lastName, email)}
          <div>
            You've been successfully unsubscribed from Popshop Live's email
            newsletter.
          </div>
        </Description>
      );
    }

    return (
      <Container>
        <Logo />
        <Content>
          <Box>{content}</Box>
        </Content>
      </Container>
    );
  }
}

export default UnsubscribePage;
